// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__U2Gt2"};